// import external dependencies

import "jquery";
// import "slick-carousel";
import AOS from "aos";

// Import everything from autoload
import "./autoload/_foundation.js";
import "./modules/map.js";

jQuery(document).ready(() => {
	$(document).on("click", ".back-to-top", function(event) {
		event.preventDefault();
		if (
			location.pathname.replace(/^\//, "") ==
				this.pathname.replace(/^\//, "") &&
			location.hostname == this.hostname
		) {
			var target = $(this.hash);
			target = target.length ? target : $("[id=" + this.hash.slice(1) + "]");

			if (target.length) {
				event.preventDefault();
				$("html, body").animate(
					{
						scrollTop: target.offset().top,
					},
					1000,
					function() {
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) {
							return false;
						} else {
							$target.attr("tabindex", "-1");
							$target.focus();
						}
					}
				);
			}
		}
	});
	$("[data-product-slider]").slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					infinite: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});
	$(".category-list__item input:checkbox").click(function() {
		$(".category-list__item input:checkbox")
			.not(this)
			.prop("checked", false);
	});
});

let menuIcon = document.querySelector(".menu-icon");

if (menuIcon) {
	menuIcon.addEventListener("click", () => {
		menuIcon.classList.toggle("active");
	});
}

window.addEventListener("resize", () => {
	menuIcon.classList.remove("active");
});

let heroVideo = document.getElementById("bgvideo");
let playButton = document.querySelector(".play-button");
let blockSpacer = document.querySelectorAll(".wp-block-spacer");

async function playVideo() {
	try {
		await heroVideo.play();
		playButton.classList.add("playing");
	} catch (err) {
		playButton.classList.remove("playing");
	}
}

let handlePlayButton = () => {
	if (heroVideo.paused) {
		playVideo();
	} else {
		heroVideo.pause();
		playButton.classList.remove("playing");
	}
};

let changeSpacerHeight = () => {
	blockSpacer.forEach(item => {
		var spacerHeight = item.getAttribute("spacer-height");
		item.style.height = parseInt(spacerHeight) / 2 + "px";
	});
};

if (playButton) {
	playButton.addEventListener("click", handlePlayButton, false);
}

window.onload = function() {
	AOS.init();

	blockSpacer.forEach(item => {
		item.setAttribute("spacer-height", item.style.height);
	});

	if (window.innerWidth < 1023) {
		changeSpacerHeight();
	}

	window.addEventListener(
		"resize",
		function() {
			if (window.innerWidth > 1023) {
				blockSpacer.forEach(item => {
					item.style.height = item.getAttribute("spacer-height");
				});
			} else {
				changeSpacerHeight();
			}
		},
		true
	);
};

let tabBtnNew = document.querySelectorAll(".tabs-section__btn-title");

function addClassSiblings(classNames) {
	var cs = this.nextElementSibling;
	while (cs) {
		cs.classList.remove(classNames);
		cs = cs.nextElementSibling;
	}

	cs = this.previousElementSibling;
	while (cs) {
		cs.classList.remove(classNames);
		cs = cs.previousElementSibling;
	}
}

tabBtnNew.forEach(item => {
	item.addEventListener("click", function() {
		this.classList.add("active");
		addClassSiblings.bind(this, "active")();
		let dataTab = this.getAttribute("data-tab");
		let tabContent = document.querySelector("#" + dataTab + "");
		tabContent.classList.add("active");
		addClassSiblings.bind(tabContent, "active")();
	});
});

let productCat = document.querySelectorAll("[data-body-term]");

productCat.forEach(item => {
	let body = document.querySelector("body");
	let bodyTerm = item.getAttribute("data-body-term");
	if (body.classList.contains(bodyTerm)) {
		item.checked = true;
	}
});



// WEBPACK FOOTER //
// ./scripts/main.js